export default __webpack_public_path__ + "static/PE-2-a192efed9a107fa30c3eb0df6fde31e0.png";